<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50" v-if="showModal">
    <div class="bg-white bg-opacity-10 backdrop-blur-xl p-8 rounded-2xl w-full max-w-md border border-white border-opacity-20 shadow-2xl transform transition-all duration-300">
      <!-- Component Content -->
      <component 
        :is="currentStepComponent" 
        v-bind="currentStepProps" 
        @close="closeModal" 
        @next="nextStep" 
        @prev="prevStep">
      </component>
      
      <!-- Navigation Buttons -->
      <div class="mt-6 flex justify-between" v-if="currentStepComponent !== 'StepInterviewType' && currentStepComponent !== 'StepPredefined'">
        <!-- Previous Button -->
        <button 
          v-if="currentStep > 1" 
          class="bg-white bg-opacity-20 backdrop-blur-sm hover:bg-opacity-30 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 hover:shadow-lg transform hover:scale-105 shadow-md border border-white border-opacity-20"
          @click="prevStep">
          <span class="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
            Anterior
          </span>
        </button>
        <div v-else></div>
        
        <!-- Next Button -->
        <button 
          v-if="currentStep < steps.length" 
          class="bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 hover:shadow-lg transform hover:scale-105 hover:-translate-y-1 shadow-md"
          @click="nextStep">
          <span class="flex items-center">
            Siguiente
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </span>
        </button>
        
        <!-- Start Button -->
        <button
          v-if="currentStep === steps.length"
          :class="{
            'bg-gradient-to-r from-green-400 to-green-500 hover:from-green-500 hover:to-green-600 text-white shadow-md': interviewFocus,
            'bg-gray-400 bg-opacity-50 text-white text-opacity-50 cursor-not-allowed': !interviewFocus
          }"
          class="font-bold py-3 px-6 rounded-full transition-all duration-300 hover:shadow-lg transform hover:scale-105 hover:-translate-y-1"
          :disabled="!interviewFocus"
          @click="finishSetup"
        >
          <span class="flex items-center">
            Comenzar
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import {
      StepIntroduction,
      StepInterviewType,
      StepPredefined,
      StepCustomJob,
      StepCustomCandidate,
      StepInterviewFocus
  } from './index.js';

  import axios from 'axios'; 
  
  export default {
      emits: ['update:interviewCodeGenerated', 'update:chatSessionId', 'close'],
      props: {
          interviewCodeGenerated: {
              type: Boolean,
              required: false,
              default: false,
          },
          chatSessionId: {
              type: String,
               required: false,
              default: null
          }
      },
    components: {
      StepIntroduction,
      StepInterviewType,
      StepPredefined,
      StepCustomJob,
      StepCustomCandidate,
      StepInterviewFocus
    },
    data() {
      return {
          currentStep: 1,
          interviewType: null,
          predefinedInterview: null,
          jobDescription: {
              jobTitle: '',
              requirements: '',
              skills: '',
              responsibilities: '',
          },
          candidateDetails: {
              name: '',
              education: '',
              experience: '',
          },
          interviewFocus: null,
          showModal: true,
      };
    },
    computed: {
      steps() {
          return [
              { component: 'StepIntroduction' },
              { component: 'StepInterviewType' },
               ...(this.interviewType === 'predefined'
                ? [{ component: 'StepPredefined' }]
                 : this.interviewType === 'custom'
                  ? [{ component: 'StepCustomJob'},{component: 'StepCustomCandidate'},{component: 'StepInterviewFocus'}]
                    : []),
          ];
      },
        currentStepComponent() {
           console.log('Current Step: ', this.currentStep, 'Component: ', this.steps[this.currentStep - 1]?.component);
        return this.steps[this.currentStep - 1]?.component;
      },
       currentStepProps() {
        return {
           interviewType: this.interviewType,
           predefinedInterview: this.predefinedInterview,
           jobDescription: this.jobDescription,
            candidateDetails: this.candidateDetails,
            interviewFocus: this.interviewFocus,
            setInterviewType: this.setInterviewType,
            setPredefinedInterview: this.setPredefinedInterview,
            setJobDescription: this.setJobDescription,
            setCandidateDetails: this.setCandidateDetails,
            setInterviewFocus: this.setInterviewFocus,
             setInterviewCodeGenerated: this.setInterviewCodeGenerated,
            setChatSessionId: this.setChatSessionId
        };
      }
    },
    methods: {
      nextStep() {
          this.currentStep++;
      },
      prevStep(){
        this.currentStep--;
      },
       closeModal() {
           console.log('closeModal called');
          this.showModal = false;
          this.$emit('close');
        },
         finishSetup() {
            // Crear el documento en Firestore
            const {jobTitle, requirements, skills, responsibilities} = this.jobDescription
            const {name, education, experience } = this.candidateDetails;

            const jobDescriptionString = `Nombre del puesto: ${jobTitle}. Requisitos: ${requirements}. Habilidades: ${skills}. Responsabilidades: ${responsibilities}`;
            const candidateCVString = `Nombre: ${name}. Educación: ${education}. Experiencia: ${experience}`;

            // Llamar al endpoint para crear la sesion personalizada
            this.createCustomSession(jobDescriptionString, candidateCVString, this.interviewFocus);
        },
       setInterviewType(type) {
          this.interviewType = type;
          console.log("Set type" + type);
      },
      setPredefinedInterview(interview){
        this.predefinedInterview = interview;
        console.log("Set predefined " + interview);
      },
      setJobDescription(description) {
        this.jobDescription = { ...this.jobDescription, ...description };
        console.log("Set description" + JSON.stringify(description));
      },
      setCandidateDetails(details) {
        this.candidateDetails = { ...this.candidateDetails, ...details };
        console.log("Set details" + JSON.stringify(details));
      },
       setInterviewFocus(focus){
        this.interviewFocus = focus;
        console.log("Set focus" + focus);
      },
        setInterviewCodeGenerated(value){
         this.$emit('update:interviewCodeGenerated',value);
      },
       setChatSessionId(value){
          this.$emit('update:chatSessionId', value);
      },
      async createCustomSession(jobDescriptionString, candidateCVString, interviewFocus){
          try {
              const response = await axios.post(`/api/generate-code`, {
                 jobDescription: jobDescriptionString,
                  candidateCV: candidateCVString,
                   interviewFocus: interviewFocus
              });
                console.log("Response from server", response.data);
                
                this.setChatSessionId(response.data.chatSessionId);
                this.setInterviewCodeGenerated(response.data.newChatSession);
                this.$emit('close');

          } catch(error){
               console.error("Error al crear documento en Firestore", error);
                 alert("Error al crear la sesión. Por favor, intenta de nuevo más tarde.");
          }
    }

    },
  };
  </script>

<style scoped>
.backdrop-blur-sm {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.backdrop-blur-xl {
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.hover\:scale-105:hover {
  transform: scale(1.05);
}

.hover\:-translate-y-1:hover {
  transform: translateY(-4px);
}
</style>